module.exports = __webpack_public_path__ + "media/APP-download.a8aa5ae8.mp4";